


function Loading() {
  
  return (
<div className='pre-loader-wrap'>
    <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        </div>
        </div>
  );
}

export default Loading;